const data = {
  SET_USER: 'SET_USER',
  SET_TOKEN: 'SET_TOKEN',
  SET_COMPANYID: 'SET_COMPANYID'
}

export default data
